const apiBase = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export const BLOG_PLACEHOLDER = "/upload/placeholder-image.svg";
export const COURSE_PLACEHOLDER = "/upload/course_category.png";

export const blogImageSrc = (image, fallback = BLOG_PLACEHOLDER) => {
  const src = image || fallback;
  if (/^https?:\/\//i.test(src)) return src;
  const relative = src.startsWith("/") ? src : `/${src}`;
  return `${apiBase}${relative}`;
};
